import {
  Component,
} from '@angular/core';
import {Router} from '@angular/router';
import {Path} from '@core/enums';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})

export class NavbarComponent {

  // Check user type
  userType: string;
  constructor(
    private router: Router
  ) {
    const storedItems = JSON.parse(localStorage.getItem('_user'));
    console.log('storedItems', storedItems);
    this.userType = storedItems.userType;
  }

  // tslint:disable-next-line:use-lifecycle-interface
  ngOnInit(): void {}

  // TODO: Add navigation functionality
  onButtonClick = (pageDestination) => {
    this.router.navigate(['/' + pageDestination]);
  }

  goToGabadooFaq(){
    window.location.href = 'https://www.gabadoo.com/apps/help-center';
   // window.open('https://www.gabadoo.com/apps/help-center', '_blank');
  }

  goToParentHomePage() {
    this.router.navigate([`/${Path.ParentHome}`]);
  }

  goToGabadooPage() {
    this.router.navigate([`/${Path.Gabadoo}`]);
  }

  goToParentAccount() {
    this.router.navigate([`/${Path.ParentAccount}`]);
  }

  // Partner buttons
  goToPartnerHomePage() {
    this.router.navigate([`/${Path.PartnerHome}`]);
  }

  goToGabadooPageForPartner() {
    this.router.navigate([`${Path.PartnerGabadoo}`]);
  }

  goToPartnerAccount() {
    this.router.navigate([`/${Path.PartnerAccount}`]);
  }
}
